import React, { useEffect, useState } from "react";
import Search from "../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../assets/svg/svg27.svg"; 
import svg12 from "../../assets/svg/svg12.svg"; 
import svg15 from "../../assets/svg/svg15.svg";
import BreadCrumb from "../../layout/BreadCrumb";
import CardLoading from "../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import {  fetchData } from "../../features/fetch/fetchSlice";
import { setActiveObj } from "../../features/obj/objSlice";
import { formatText } from "../../utils";

function FarmersTable() {
  const navigate =  useNavigate()
  const dispatch = useDispatch()
  const url = "api/v2/getFarmers";
  const urlFarmer = "api/v2/flid/dashboard/mainParams";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],     
    count: state.fetch.count[url] || 0,    
  }));

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
      dispatch(
        fetchData({
          url:'api/v2/getFarmers',
          fullName: e.target.value == "" ? null : e.target.value,
        })
      );
  };

  const handleEdit =async () => { 
    await dispatch(setActiveObj({ key: "farmers", data: prodd })); 
    await navigate('/farmers-add')
  };
  const handleDisable = () => {};
  const handleAdd = async() => {
    await dispatch(setActiveObj({ key: "farmers", data: {} })); 
    await navigate('/farmers-add')
  };
  const handleView=async()=>{
    await dispatch(fetchData({
      url:urlFarmer,
      usrId:prodd?.usrId,
      limit: null,
      start:0,
    })) 
    await dispatch(setActiveObj({ key: "farmers", data: prodd })); 
    await navigate('/farmer-view')
  }
  const handleViewName=async(item)=>{  
      await dispatch(fetchData({
        url:urlFarmer,
        usrId:item?.usrId,
        limit: null,
        start:0,
      })) 
    await dispatch(setActiveObj({ key: "farmers", data: item })); 
    await navigate('/farmer-view')
  }
  
  const settingItems = [
    {
      key: "1",
      label: (
        <div  onClick={handleEdit}>
        <Link 
          className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 "
        >
         <img src={svg12} alt="svg12"/> Edit
        </Link>
        <div className="mt-[1rem]">
          <Divider />
        </div>
      </div> 
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
        <Link 
          className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 "
        >
          <img src={svg15} alt="svg15" /> View
        </Link>
       
      </div>  
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Full Names", 
      render:(item)=>{
        return(
          <div className="cursor-pointer" onClick={()=>handleViewName(item)}>{item?.fullNames}</div>
        )
      },
      sorter: (a, b) => a.fullNames.localeCompare(b.fullNames),
    },
    
    {
      title: "Email Address",
      dataIndex: "email",
      sorter: (a, b) => a.email.localeCompare(b.email),
    },
    {
      title: "Mobile Number",
      dataIndex: "phoneNumber",
      sorter: (a, b) => a.phoneNumber.localeCompare(b.phoneNumber),
    },
    {
      title: "National ID",
      dataIndex: "usrNationalId",
      sorter: (a, b) => a.usrNationalId.localeCompare(b.usrNationalId),
    },
    {
      title: "County",
      dataIndex: "usrCountyName",
      sorter: (a, b) => a.usrCountyName.localeCompare(b.usrCountyName),
    },
    {
      title: "Status",
      dataIndex: "usrStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#28A745",
          PENDING_APPROVAL: "#3250FF",
          INACTIVE: "#F44336",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[8px] px-[8px] py-[4px] w-auto !text-[12px]"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {formatText(item)}
          </div>
        );
      },
    },
 
    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];
 

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchFarmersData(page, size) {
    await dispatch(fetchData({
      url:url,
      limit: size ?? pageSize,
      start: page ?? pageIndex,
    }))
  }
 
  useEffect(() => {
    fetchFarmersData() 
  }, []);
 
  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col"> 
        <BreadCrumb
          breadcrumbs={[ 
            { title: "Farmers"},
          ]}
        /> 
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[1.25rem] gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search farmer..."}
            />
          </div> 
          <div className="w-[130px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <span className="">Add New</span>
            </button>
          </div>
        </div>

        <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
          <section>
            <Table
              rowSelection={false}
              className="mt-[1.31rem] w-full"
              scroll={{
                x: 1200,
              }}
              rowKey={(record) => record?.usrId}
              columns={columns}
              dataSource={data}
              loading={loading}
              pagination={{
                position: ["bottomRight"],
                current: pageIndex + 1,
                total: count,
                pageSize: pageSize,
                onChange: (page, size) => {
                  setPageIndex(page - 1);
                  setPageSize(size);
                  fetchFarmersData(page - 1, size);
                },
                showSizeChanger: false,
                hideOnSinglePage: true,
              }}

              
            />
          </section>
        </div>
      </div>
    </div>
  );
}

export default FarmersTable;